<div class="flex-direction-column gap-15 card-exibicao-template" [style]="template ? 'justify-content: flex-start' : ''">
  @if (template) {
    <div>
      <span class="font-12 weight-600">Visualização da Mensagem</span>
    </div>
    <div class="width-100 flex justify-center">
      <app-template-mensagem
        [tipo]="tipo"
        [template]="template"
        [variaveis]="variaveis"
      >
      </app-template-mensagem>
    </div>
    <div class="flex-direction-column gap-10">
        @for (componente of template.components; track componente.id) {
          @if (componente.type === 'BODY' && componente.example && componente.example.length > 0) {
            <div>
              <span class="font-12 weight-700">Variáveis</span>
            </div>
            @for (exemplo of componente.example; track exemplo.id) {
              <div class="flex-direction-column gap-5">
                <div class="flex-direction-column gap-5">
                  <div class="flex gap-10">
                    <span class="font-16 weight-700" [style.color]="'#993DF5'">[{{ exemplo.ordem }}]</span>
                    <app-slide-toggle-padrao
                      [labelTrue]="'Campos Contato'"
                      [labelFalse]="'Texto'"
                      [disabled]="disabled"
                      [valor]="variaveis[exemplo.ordem! - 1].isCampoContato"
                      (changeValue)="selecionarTipoVariavel(exemplo.ordem! - 1, $event)">
                    </app-slide-toggle-padrao>
                  </div>
                  @if (variaveis[exemplo.ordem! - 1].isCampoContato) {
                    <app-select-one
                      label="Selecione o tipo de campo dos contatos (Nome, E-mail, Telefone e CPF/CNPJ)."
                      heightFormField="35px"
                      placeholder="Selecione"
                      [listaInput]="camposVariaveis"
                      [habilitarBusca]="true"
                      [disabled]="disabled"
                      [itemSelecionado]="variaveis[exemplo.ordem! - 1].tipoCampoContato"
                      (selecionarItem)="selecionarCampoContato(exemplo.ordem! - 1, $event)">
                    </app-select-one>
                  }
                  @else {
                    <app-form-field
                      label="Digite o texto a ser adicionado a mensagem. "
                      heightFormField="35px"
                      [value]="variaveis[exemplo.ordem! - 1].valor"
                      [disabled]="disabled"
                      (changeValue)="selecionarTextoVariavel($event, exemplo.ordem! - 1)">
                    </app-form-field>
                  }
                </div>
              </div>
            }
          }
        }
    </div>
  }
  @else {
    <div class="flex center-center balao-informativo">
      <app-balao-informativo
        [titulo]="tipo === 'sms' ? 'Nenhum Template de SMS Selecionado' : 'Nenhum Template Selecionado'"
        [width]="'249px'"
        [heigth]="'122px'"
      >
      </app-balao-informativo>
    </div>
  }
</div>
